import Link from "next/link";
import PropTypes from "prop-types";
import { useState } from "react";
import { linkPropTypes } from "utils/types";

import downloadApp from "./download-link";
import BasicModal from "./modal";

const CustomLink = ({ link, children, onmouuid = "" }) => {
  const isInternalLink = link.url.startsWith("/");
  const [open, setOpen] = useState(false);

  // For internal links, use the Next.js Link component
  if (isInternalLink) {
    if (link.newTab) {
      return (
        <Link
          passHref
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </Link>
      );
    }
    return (
      <Link
        passHref
        href={onmouuid ? `${link.url}?onmouuid=${onmouuid}` : link.url}
        replace={false}
      >
        {children}
      </Link>
    );
  }

  if (link.url === ":modal") {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
      <>
        <BasicModal handleClose={handleClose} open={open} />
        <a className="hidden md:block" onClick={handleOpen}>
          {children}
        </a>
        <a className="block md:hidden" onClick={downloadApp}>
          {children}
        </a>
      </>
    );
  }

  // Plain <a> tags for external links
  if (link.newTab) {
    return (
      <a href={link.url} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <a href={link.url} target="_self">
      {children}
    </a>
  );
};

CustomLink.propTypes = {
  link: linkPropTypes,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default CustomLink;
